import {DEFAULT_PAGE_NUMBER, ORDER, SORT_FIELDS as COMMON_SORT_FIELDS} from '../base.js'

export const HAS_VEHICLE_INFO_COMPETITORS = true

export const HAS_MODEL_PAGE = false

export const TECHNICAL_DETAILS_SEARCH_URL = '/fichas_tecnicas/buscador.aspx'

export const TECHNICAL_DETAILS_EMPTY_VEHICLE_IMAGE = 'images/no-photo.png'

export const TECHNICAL_DETAILS_DEFAULT_VEHICLE_ID = 0

export const TECHNICAL_DETAILS_VERSIONS_TABLE_CONFIG = 'YEAR_VERSION_FUEL_CC'

export const DEFAULT_SEARCH = {
  page: DEFAULT_PAGE_NUMBER,
  sortBy: COMMON_SORT_FIELDS.TITLE,
  sortOrder: ORDER.ASC
}
